import { useEffect } from 'react';

export function useScrollToTop(dependency: any) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dependency]);
}